/// <amd-module name="Search/Shared/Components/SearchInput" />
export * from "./SearchInput/index";
